// DS: PO56
import React from 'react';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { Trans, useTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import Button from '../../Button';
import s from './CookiesBanner.scss';
const CookiesBanner = ({ onAccept, onManageInfo })=>{
    const { t } = useTranslation();
    const handleManageInfoClick = (e)=>{
        onManageInfo();
        e.preventDefault();
        return false;
    };
    const handleAcceptClick = (e)=>{
        onAccept();
    };
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root']
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['details']
    }, /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: "popup.cookiesbanner.details"
    }, "We use cookies to enhance your experience, analyze site traffic, and for our marketing purposes. ", /*#__PURE__*/ React.createElement("a", {
        href: URLS.PRIVACY
    }, "Learn More")), /*#__PURE__*/ React.createElement("br", null), /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: "popup.cookiesbanner.manage_info"
    }, "Manage your", ' ', /*#__PURE__*/ React.createElement(BiLink, {
        className: s['manage-info'],
        onClick: handleManageInfoClick,
        href: "#"
    }, "personal settings."))), /*#__PURE__*/ React.createElement("div", {
        className: s['buttons']
    }, /*#__PURE__*/ React.createElement(Button, {
        view: 'b1-1',
        height: 'small',
        minWidth: '120px',
        fullWidth: true,
        onClick: handleAcceptClick,
        className: s['accept']
    }, t('popup.cookiesbanner.accept'))));
};
CookiesBanner.displayName = 'CookiesBanner';
export default CookiesBanner;
